import React, { useState, useEffect } from 'react'
import { observer } from 'mobx-react'
import { advertMobx } from '@mobxStore'
import { isEmpty } from '@dt/fe-utils/dist/lodash'
import { Advert as MenuAdvert } from '@cps'
import './index.scss'

interface IOpenScreenProps {
  isShow: boolean;
}

let timer: NodeJS.Timeout

const OpenScreen: React.FC<IOpenScreenProps> = (props) => {
  const { advertInfo: { openScreen }, availableAdsMap } = advertMobx
  const [isShow, setIsShow] = useState(props.isShow as boolean)
  const [seconds, setSeconds] = useState(0)
  const type = 'openScreen'

  // 跳过
  const handleSkipAd = () => {
    setIsShow(false)
  }

  // useEffect seconds
  useEffect(() => {
    if (isShow) {
      timer = setTimeout(() => {
        if (seconds === 1) {
          timer && clearTimeout(timer)
          timer && (timer = null)
          handleSkipAd()
          return
        }
        if (seconds > 0) {
          setSeconds(seconds - 1)
        }
      }, 1000)
    }
    return () => {
      timer && clearTimeout(timer)
      timer && (timer = null)
    }
  }, [seconds])

  // useEffect openScreen
  useEffect(() => {
    setSeconds(openScreen?.outTime || 0)
  }, [openScreen])

  useEffect(() => {
    // 没有图片就直接隐藏
    if (!availableAdsMap?.[type]?.length) {
      handleSkipAd()
    }
  }, [availableAdsMap[type]])

  return (
    isShow && !isEmpty(openScreen) && openScreen?.ads?.[0]?.pic ? (
      <div className='open-screen-wrapper'>
        <div className='open-screen-packet' data-cypid='openScreenSkip' onClick={handleSkipAd}>
          {i18n.t('advert.skip')}{seconds}
        </div>
        <MenuAdvert type='openScreen' onClick={handleSkipAd} />
      </div>
    ) : null
  )
}

export default observer(OpenScreen)
